import { DataSource, Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutDatafusionBillingOutboundErrors extends Layout {
    labelInDatafusionBilling: Label;
    labelTotal: Label;
    sourceEdibillingCount: DataSource;
}
